<template>
  <div>
    <loading />
    <error-message ref="errorDialog" />
  </div>
</template>

<script>
import Loading from "@/components/Loading.vue";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: { Loading, ErrorMessage },
  mounted() {
    // ツイッター認証をキャンセルした場合はhomeに戻る
    if (this.$route.query.hasOwnProperty("denied")) {
      this.$router.push({ name: "home" });
      return;
    }

    this.$http
      .post(`/v1/users/auth`, {
        oauth_token: this.$route.query.oauth_token,
        oauth_verifier: this.$route.query.oauth_verifier
      })
      .then(res => {
        this.$store.commit("setTwitterAccount", {
          userName: res.data.twitter_name,
          userImageUrl: res.data.profile_image_url,
          twitterScreenName: res.data.twitter_screen_name
        });
        this.$store.commit("login", {
          token: res.data.access_token,
          user_id: res.data.user_id
        });

        const routeName = this.$store.state.login_callback_route_name;
        if (this.$store.state.login_callback_route_query) {
          const routeQuery = this.$store.state.login_callback_route_query;
          this.$router.push({ name: routeName, query: { id: routeQuery } });
        } else {
          this.$router.push({ name: routeName });
        }
      })
      .catch(error => {
        this.$refs.errorDialog.setMessage(
          "認証処理に失敗しました。詳細：[" +
            error.response.status +
            "] " +
            error.response.statusText
        );
        this.$router.push({
          name: "home",
          params: { response: error.response }
        });
      });
  }
};
</script>
